import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface WorkspaceSearchParams {
  keyword?: string;
  officeId?: string;
  readinessStatus?: string;
  workspaceName?: string;
  floor?: string;
  limit?: number;
  inspectionDateFrom?: string,
  inspectionDateTo?: string,
  inspectionPeriod?: string,
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getWorkspace = async (params: WorkspaceSearchParams = {}) => {
  const response = await axiosInstance.get("/building/workspace-readiness/search_workspace_readiness", {
    params,
  });
  return response.data;
};


export const fetchWorkspacePhotoBlob = async (filename: string): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(`/building/workspace-readiness/photo/${filename}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};



// Step 1: Create Project
export const createWorkspace = async (data) => {
  const response = await axiosInstance.post(`/building/workspace-readiness/create_workspace_readiness`, data);
  return response.data; // contains the project `id` or `code`
};


// Step 2: Upload Photo by Project ID
export const uploadWorkspacePhoto = async (rabId, file) => {
  const formData = new FormData();
  formData.append("photo", file);

  return axiosInstance.post(`/building/workspace-readiness/upload_photo/${rabId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Edit Project
export const editWorkspace = async (data) => {
  const formData = {
    projectName: data.projectName,
    projectAddress: data.projectAddress,
    region: data.region,
    projectType: data.projectType,
    projectEmail: data.projectEmail,
    managerName: data.managerName,
    contactNumber: data.contactNumber,
  };

  const response = await axiosInstance.put(`/building/workspace-readiness/update_workspace_readiness/${data.id}`, data);
  return response.data; // contains the project `id` or `code`
};

export const deleteWorkspace = async (projectId: string) => {
  const response = await axiosInstance.delete(`/building/workspace-readiness/delete_workspace_readiness/${projectId}`);
  return response.data;
};


// Cleaning

export interface CleaningSearchParams {
  keyword?: string;
  workspaceReadinessId?: string;
  cleaningInfo?: string;
  cleaningDate?: string;
  user?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getCleaning = async (params: CleaningSearchParams = {}) => {
  const response = await axiosInstance.get("/building/cleaning-history/search_cleaning_histories", {
    params,
  });
  return response.data;
};

export const viewCleaning = async (id: string) => {
  const response = await axiosInstance.get(`/building/cleaning-history/view_cleaning_history/${id}`);
  return response.data;
};


export const createCleaning = async (data) => {
  const response = await axiosInstance.post(`/building/cleaning-history/create_cleaning_history`, data);
  return response.data; // contains the project `id` or `code`
};


export const editCleaning = async (data) => {

  const response = await axiosInstance.put(`/building/cleaning-history/update_cleaning_history/${data.id}`, data);
  return response.data; // contains the project `id` or `code`
};

export const deleteCleaning = async (id: string) => {
  const response = await axiosInstance.delete(`/building/cleaning-history/delete_cleaning_history/${id}`);
  return response.data;
};